import { HITS_TYPES_BY_URL, SendHitsEvent } from '~/pages/DiscoverPage/const';

export const sendAlgoliaClickEvent = (sendEvent: SendHitsEvent, hit) => {
  if (sendEvent) {
    sendEvent('click', hit, 'Hit clicked');
  }
};

export const calcSerpType = (pathname = '') => {
  let type;
  const typeRegExp = new RegExp('[^/]+/?$', 'g');
  const match = pathname.match(typeRegExp);
  if (match && match[0]) {
    type = match[0].replace(/\/$/, '');
  }

  return HITS_TYPES_BY_URL[type];
};
